/**
 * icon:菜单项图标
 * roles:标明当前菜单项在何种角色下可以显示，如果不写此选项，表示该菜单项完全公开，在任何角色下都显示
 */
const menuList = [
  {
    title: "汇总",
    path: "/summary",
    icon: "dashboard",
    roles: ["admin", "hospital_admin", "hospital_doctor", "hospital_health_manager"]
  },
  {
    title: "下单列表",
    path: "/order-list",
    icon: "unordered-list",
    roles: ["admin", "hospital_admin", "hospital_doctor", "hospital_health_manager"]
  },
  {
    title: "病人列表",
    path: "/hospital-patient-list",
    icon: "team",
    roles: ["admin", "hospital_admin", "hospital_doctor", "hospital_health_manager"]
  },
  {
    title: "指导医生列表",
    path: "/director-doctor",
    icon: "solution",
    roles: ["admin", "hospital_admin"]
  },
  {
    title: "健康管理师列表",
    path: "/health-manager-list",
    icon: "usergroup-add",
    roles: ["admin", "hospital_admin"]
  },
  {
    title: "健康管理组",
    path: "/health-management-group",
    icon: "team",
    roles: ["admin", "hospital_admin"]
  },
  {
    title: "首页",
    path: "/dashboard",
    icon: "home",
    roles: ["admin", "editor", "guest"]
  },
  {
    title: "用户管理",
    path: "/user",
    icon: "team",
    roles: ["admin", "editor"]
  },
  // {
  //   title: "权限测试",
  //   path: "/permission",
  //   icon: "lock",
  //   children: [
  //     {
  //       title: "admin页面",
  //       path: "/permission/adminPage",
  //       roles:["admin"]
  //     },
  //     {
  //       title: "guest页面",
  //       path: "/permission/guestPage",
  //       roles:["guest"]
  //     },
  //     {
  //       title: "editor页面",
  //       path: "/permission/editorPage",
  //       roles:["editor"]
  //     },
  //   ],
  // },
  {
    title: "专科医生工作台",
    path: "/doctor-workbench",
    icon: "medicine-box",
    roles: ["admin", "editor", "doctor"]
  },
  {
    title: "预警中心",
    path: "/warning",
    icon: "alert",
    roles: ["admin", "editor", "guest"]
  },
  {
    title: "消息中心",
    path: "/message-center",
    icon: "message",
    roles: ["admin", "editor", "guest", "health-manager", "doctor"]
  },
  {
    title: "体检管理",
    path: "/medical",
    icon: "medicine-box",
    roles: ["admin", "editor"],
    children: [
      {
        title: "体检团体活动",
        path: "/medical-activities",
        roles: ["admin", "editor"]
      },
      {
        title: "问卷管理",
        path: "/questionnaire",
        roles: ["admin", "editor"]
      },
      {
        title: "体检订单管理",
        path: "/medical-check",
        roles: ["admin", "editor"]
      },
    ]
  },
  {
    title: "套餐管理",
    path: "/package-management",
    icon: "profile",
    roles: ["admin", "editor"],
    children: [
      {
        title: "体检套餐管理",
        path: "/physical-package",
        roles: ["admin", "editor"]
      },
      {
        title: "套餐类型管理",
        path: "/physical-combo-type",
        roles: ["admin", "editor"]
      },
      {
        title: "轮播图管理",
        path: "/physical-banner",
        roles: ["admin", "editor"]
      },
      {
        title: "医院管理",
        path: "/physical-hospital",
        roles: ["admin", "editor"]
      },
      {
        title: "1+x管理",
        path: "/one-plus-x",
        roles: ["admin", "editor"]
      },
      {
        title: "线下开单",
        path: "/medical/offline-order",
        roles: ["admin", "editor"]
      },
    ]
  },
  {
    title: "团检管理",
    path: "/physical-group-check",
    icon: "team",
    roles: ["admin"],
    children: [
      {
        title: "系统账户管理",
        path: "/physical-group-check/account",
        roles: ["admin"]
      },
      {
        title: "短信模版管理",
        path: "/physical-group-check/sms-template",
        roles: ["admin"]
      },
    ]
  },
  {
    title: "APK管理",
    path: "/apk",
    icon: "android",
    roles: ["admin", "editor"],
    children: [
      // {
      //   title: "导出APK",
      //   path: "/apk/export",
      //   roles:["admin","editor"]
      // },
      {
        title: "上传APK",
        path: "/apk/upload",
        roles: ["admin", "editor"]
      },
      {
        title: "APK版本列表",
        path: "/apk/list",
        roles: ["admin", "editor"]
      }
    ],
  },
  {
    title: "设备中心",
    path: "/equipment",
    icon: "desktop",
    roles: ["admin", "editor"],
    children: [
      {
        title: "正式设备",
        path: "/equipment/formal",
        roles: ["admin", "editor"]
      },
      {
        title: "测试设备",
        path: "/equipment/test",
        roles: ["admin", "editor"]
      }
    ],
  },
  {
    title: "资源管理",
    path: "/resource",
    icon: "folder",
    roles: ["admin", "editor"]
  },
  {
    title: "员工管理",
    path: "/staff",
    icon: "team",
    roles: ["admin", "editor"]
  },
  {
    title: "商品中心",
    path: "/goods",
    icon: "shopping",
    roles: ["admin", "editor"],
    children: [
      {
        title: "商品管理",
        path: "/goods/management",
        roles: ["admin", "editor"]
      },
      {
        title: "商城订单管理",
        path: "/goods/orders",
        roles: ["admin"]
      }
    ]
  },
  {
    title: '积分中心',
    path: '/points',
    icon: 'trophy',
    roles: ['admin'],
    children: [
      {
        title: '积分活动与任务',
        path: '/points/activity',
        icon: 'gift',
        roles: ['admin']
      }
    ]
  },

];

export default menuList;
